<template>
  <GridLayout
    class="grid-layout"
    :class="{ 'grid-layout__display-mode': mgnlProps?.displayMode === 'fullScreen' }"
    :column="mgnlProps.column"
    :flexible-layout="mgnlProps.flexibleLayout"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import GridLayout from './GridLayout.vue';
import { GridLayoutBuilder, WrapperProps } from '~/components/Shared/GridLayout/GridLayout.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const mgnlProps = GridLayoutBuilder.build(props);
const { $domain } = useNuxtApp();

let backgroundColor: string;
let backgroundImage: string;
if (mgnlProps.switchableMode?.field === 'backgroundColor') {
  backgroundColor = magnoliaGetters.getHexColor(mgnlProps.switchableMode?.backgroundColor);
}

if (mgnlProps.switchableMode?.field === 'image') {
  backgroundImage = `url(${magnoliaGetters.getDefaultSrcAsset(mgnlProps.switchableMode?.image, $domain.cmsAssetDomainPath)})`;
}

provide('numberOfColumns', mgnlProps.column?.['@nodes'].length);
</script>

<style lang="scss" scoped>
  .grid-layout {
    background: v-bind(backgroundColor);
    background-image: v-bind(backgroundImage);
    background-size: contain;
    background-position: top center;
    background-repeat: no-repeat;

    &__display-mode {
      position: relative;
      width: 100vw;
      left: 50%;
      right: 50%;
      margin-left: -50vw;
      margin-right: -50vw;
    }
  }
</style>
